// src/components/DetectorText.js
import React from 'react';
import PropTypes from 'prop-types';
import './DetectorText.css';

const DetectorText = ({
  title = 'Create your own gestures',
  content = `FaceLead allows you to create any face gesture you can imagine. The process is simple: you just need to record a gesture for a few seconds 
    and then an AI model will dynamically learn to detect it. You can create as many gestures as you want.`,
  docLink = '/docs/traingestures'
}) => {
  return (
    <div className="chunk-container-2"> 
      <div className="chunk-content">
        <h1 className="normal-title">{title}</h1>
        <div className="detector-text"> 
          <p>{content}</p>
          <button className="learn-more-btn" onClick={() => (window.location.href = docLink)}>Learn More</button>
        </div>
      </div>
    </div>
  );
};

DetectorText.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

export default DetectorText;
